import { buildClient } from '../utils/url';
var reportsService = {
    baseUrl: {
        SERVICE: 'reports',
        BOARDS: 'boards',
        REPORTS: 'reports',
        REPORT_CATEGORIES: 'report-categories',
        HEALTH: 'health',
    },
    boards: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
        GET_DATA: '/:id/data',
        UPDATE_REPORT_GRID_DATA: '/:id/report-grid-data',
    },
    reportCategories: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
        SEARCH: '/search',
    },
    reports: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        GET_ONE_BY_KEY: '/key/:key',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
        UPDATE_GRID_DATA: '/:id/report-grid-data',
        GET_GRAPH_DATA: '/graph-data',
        GET_REPORT_WITH_DATA: '/:key/data',
        DELETE_REPORT_GRID_DATA: '/:id/report-grid-data',
    },
    health: {
        CUBE_CHECK: '/cube',
    },
};
var reportsServiceClient = {
    boards: buildClient(reportsService.baseUrl.BOARDS, reportsService.boards),
    reports: buildClient(reportsService.baseUrl.REPORTS, reportsService.reports),
    reportCategories: buildClient(reportsService.baseUrl.REPORT_CATEGORIES, reportsService.reportCategories),
};
var reportsApiGatewayClient = {
    boards: buildClient("".concat(reportsService.baseUrl.SERVICE, "/").concat(reportsService.baseUrl.BOARDS), reportsService.boards),
    reports: buildClient("".concat(reportsService.baseUrl.SERVICE, "/").concat(reportsService.baseUrl.REPORTS), reportsService.reports),
    reportCategories: buildClient("".concat(reportsService.baseUrl.SERVICE, "/").concat(reportsService.baseUrl.REPORT_CATEGORIES), reportsService.reportCategories),
    health: buildClient("".concat(reportsService.baseUrl.SERVICE, "/").concat(reportsService.baseUrl.HEALTH), reportsService.health),
};
export { reportsService, reportsServiceClient, reportsApiGatewayClient };
//# sourceMappingURL=reports-service.js.map